import { fetchBaseQuery, createApi } from '@reduxjs/toolkit/query/react';

const statsApi = createApi({
  reducerPath: 'statsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: window.API_URL,
    credentials: 'include'
  }),
  tags: ['Stats'],
  endpoints: (builder) => ({
    getStats: builder.query({
      query: (departmentId = null) => `/stats.php?departmentId=${departmentId}`,
      providesTags: ['Stats']
    })
  })
});

export const { useGetStatsQuery } = statsApi;

export default statsApi;
